export const apiName: string = 'abastecimentos-bens';
export const abastecimentoBensRoute: string = 'abastecimento-bens';
export const abastecimentoBensStorage: string = 'abastecimento-bens';
export const abastecimentoBensModuleName: any = {plural: 'Abastecimentos', single: 'Abastecimento'};

export const months: any[] = [
    {Key: 0, Value: 'Janeiro'},
    {Key: 1, Value: 'Fevereiro'},
    {Key: 2, Value: 'Março'},
    {Key: 3, Value: 'Abril'},
    {Key: 4, Value: 'Maio'},
    {Key: 5, Value: 'Junho'},
    {Key: 6, Value: 'Julho'},
    {Key: 7, Value: 'Agosto'},
    {Key: 8, Value: 'Setembro'},
    {Key: 9, Value: 'Outubro'},
    {Key: 10, Value: 'Novembro'},
    {Key: 11, Value: 'Dezembro'}
];

export const TiposAbastecimentoBens: any[]  = [
    {Key: 1, Value: "Interno"},
    {Key: 2, Value: "Externo"},
    {Key: 3, Value: "Convênio"}
];


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimento-bens/shared/data.service.ts
 **/